import { render, staticRenderFns } from "./PortraitSelect.vue?vue&type=template&id=8131cf66&scoped=true"
import script from "./PortraitSelect.vue?vue&type=script&lang=js"
export * from "./PortraitSelect.vue?vue&type=script&lang=js"
import style0 from "./PortraitSelect.vue?vue&type=style&index=0&id=8131cf66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8131cf66",
  null
  
)

export default component.exports